import colors from '@rategravity/frontend/theme/colors';
import React from 'react';

const style = {
  container: {
    width: '100%',
    textAlign: 'center',
    fontSize: '13px',
    boxSizing: 'border-box',
    padding: '5em 1em 1em',
    color: colors.primary
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: '1em'
  },
  link: {
    fontFamily: 'Graphik-Regular',
    fontStyle: 'normal',
    fontWeight: 'normal',
    marginLeft: '9px',
    marginRight: '9px',
    marginBottom: '7px',
    whiteSpace: 'nowrap',
    letterSpacing: '0.1px',
    color: '#143F3D'
  }
};

const FooterLink = (props) => (
  <a
    href={props.href}
    className="link__hover--yellow"
    target="_blank"
    rel="noreferrer"
    style={style.link}
  >
    {props.text}
  </a>
);

export default () => {
  return (
    <footer style={style.container}>
      <div style={style.links}>
        <FooterLink text="Own Up" href="https://www.ownup.com" />
        <FooterLink text="Privacy" href="https://www.ownup.com/privacy" />
        <FooterLink text="Terms of Service" href="https://www.ownup.com/terms-conditions" />
        <FooterLink text="Licensing" href="https://www.ownup.com/licensing" />
        <FooterLink text="Education" href="https://resources.ownup.com/" />
      </div>
      <div>
        {`${String.fromCharCode(169)} Own Up ${new Date().getFullYear()} • `}
        <span className="link__hover--yellow">
          <a
            href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1450805"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#143F3D' }}
          >
            NMLS: #1450805
          </a>
        </span>
      </div>
      {process.env.DEPLOY_ENV === 'prod' ? undefined : <div>{process.env.DEPLOY_ENV}</div>}
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/footer/index.js